/* eslint-disable no-param-reassign */
import {
  GET_LIST_BRAND_REQUEST,
  GET_LIST_BRAND_SUCCESS,
  GET_LIST_BRAND_FAILURE,
  GET_BRAND_REQUEST,
  GET_BRAND_SUCCESS,
  GET_BRAND_FAILURE,
  GET_LIST_BRAND_TYPE_REQUEST,
  GET_LIST_BRAND_TYPE_SUCCESS,
  GET_LIST_BRAND_TYPE_FAILURE,
  CLEAR_BRAND
} from "src/actions/brandActions";
import produce from "immer";

const initialState = {
  brands: [],
  brand: {},
  total: 0,
  brandTypes: [],
  loading: false
};

const brandReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_BRAND_REQUEST: {
      return produce(state, (draft) => {
        draft.brands = [];
        draft.loading = true;
      });
    }

    case GET_LIST_BRAND_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.brands = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case GET_LIST_BRAND_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_BRAND_REQUEST: {
      return produce(state, (draft) => {
        draft.brand = {};
        draft.loading = true;
      });
    }

    case GET_BRAND_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.brand = response;
        draft.loading = false;
      });
    }

    case GET_BRAND_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_LIST_BRAND_TYPE_REQUEST: {
      return produce(state, (draft) => {
        draft.brandTypes = [];
        draft.loading = true;
      });
    }

    case GET_LIST_BRAND_TYPE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.brandTypes = response;
        draft.loading = false;
      });
    }

    case GET_LIST_BRAND_TYPE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_BRAND: {
      return produce(state, (draft) => {
        draft.brand = {};
      });
    }

    default: {
      return state;
    }
  }
};

export default brandReducer;
